import type { SearchRelevancyGrade } from '@aibees/shared/definition';
import type { Theme } from '@mui/material/styles';

export const gradeColorMap = (theme: Theme) => ({
  A: {
    color: theme.palette.success[500],
    textColor: theme.palette.common.white,
    backgroundColor: theme.palette.success[400],
    borderColor: theme.palette.success[600],
    stroke: theme.palette.success[700],
    fontWeight: 900,
  },
  B: {
    color: theme.palette.primary[300],
    textColor: theme.palette.common.white,
    backgroundColor: theme.palette.primary[300],
    borderColor: theme.palette.primary[500],
    stroke: theme.palette.primary[600],
    fontWeight: 700,
  },
  C: {
    color: theme.palette.warning[300],
    textColor: theme.palette.common.white,
    backgroundColor: theme.palette.warning[300],
    borderColor: theme.palette.warning[500],
    stroke: theme.palette.warning[600],
    fontWeight: 700,
  },
  D: {
    color: theme.palette.warning[500],
    textColor: theme.palette.common.white,
    backgroundColor: theme.palette.grey[400],
    borderColor: theme.palette.warning[700],
    stroke: theme.palette.warning[700],
    fontWeight: 600,
  },
  default: {
    color: theme.palette.grey[400],
    textColor: theme.palette.common.white,
    backgroundColor: theme.palette.grey[400],
    borderColor: theme.palette.grey[500],
    stroke: theme.palette.grey[600],
    fontWeight: 600,
  },
});

export const getGradeStyle = (theme: Theme, grade?: SearchRelevancyGrade) =>
  gradeColorMap(theme)[grade ?? 'default'];
